import React from 'react';


function SpellListTalentTreeComponent(props) {
    return (
        <div>
            <table className="LevelingGuideTable width100">
                <tbody>
                    <tr>
                        <th><b>Skill Points</b></th>
                        <th><b>Level 1</b></th>
                        <th><b>Level 2</b></th>
                        <th><b>Level 3</b></th>
                        <th><b>Level 4</b></th>
                        <th><b>Level 5</b></th>
                        <th><b>Level 6</b></th>
                        <th><b>Level 7</b></th>
                        <th><b>Level 8</b></th>
                        <th><b>Level 9</b></th>
                    </tr>
                    <tr>
                        <td><b>1</b></td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td><b>2</b></td>
                        <td>3</td>
                    </tr>
                    <tr>
                        <td><b>3</b></td>
                        <td>4</td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td><b>4</b></td>
                        <td>4</td>
                        <td>3</td>
                    </tr>
                    <tr>
                        <td><b>5</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td><b>6</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                    </tr>
                    <tr>
                        <td><b>7</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>8</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td><b>9</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>10</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                    </tr>
                    <tr>
                        <td><b>11</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>12</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>13</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>14</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>15</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>16</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>17</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>18</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>19</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                    <tr>
                        <td><b>20</b></td>
                        <td>4</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>3</td>
                        <td>2</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                    </tr>
                </tbody>
            </table>
        </div >
    );
}

export { SpellListTalentTreeComponent };